var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0313 15.4456V14.6956C16.8324 14.6956 16.6417 14.7746 16.501 14.9153L17.0313 15.4456ZM12.2756 20.2013H11.5256C11.5256 20.5046 11.7084 20.7781 11.9886 20.8942C12.2689 21.0103 12.5915 20.9461 12.806 20.7316L12.2756 20.2013ZM12.2756 15.4456H13.0256C13.0256 15.0314 12.6899 14.6956 12.2756 14.6956V15.4456ZM14.5001 6.76953C14.0859 6.76953 13.7501 7.10533 13.7501 7.51953C13.7501 7.93373 14.0859 8.26953 14.5001 8.26953V6.76953ZM29.7131 14.6956H17.0313V16.1956H29.7131V14.6956ZM16.501 14.9153L11.7453 19.671L12.806 20.7316L17.5617 15.9759L16.501 14.9153ZM13.0256 20.2013V15.4456H11.5256V20.2013H13.0256ZM12.2756 14.6956H9.10522V16.1956H12.2756V14.6956ZM9.10522 14.6956C8.64392 14.6956 8.27002 14.3217 8.27002 13.8604H6.77002C6.77002 15.1501 7.81552 16.1956 9.10522 16.1956V14.6956ZM29.7131 8.26953C30.1744 8.26953 30.5484 8.64343 30.5484 9.10473H32.0484C32.0484 7.81503 31.0029 6.76953 29.7131 6.76953V8.26953ZM30.5484 9.10473V13.8604H32.0484V9.10473H30.5484ZM30.5484 13.8604C30.5484 14.3217 30.1744 14.6956 29.7131 14.6956V16.1956C31.0029 16.1956 32.0484 15.1501 32.0484 13.8604H30.5484ZM14.5001 8.26953H29.7131V6.76953H14.5001V8.26953Z",
    fill: "#3F2C26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10522 18.6152C8.22972 18.6152 7.52002 19.3249 7.52002 20.2004V24.9561C7.52002 25.8316 8.22972 26.5414 9.10522 26.5414H21.787L26.5427 31.297V26.5414H29.7131C30.5886 26.5414 31.2984 25.8316 31.2984 24.9561V20.2004C31.2984 19.3249 30.5886 18.6152 29.7131 18.6152H18.6166",
    stroke: "#3F2C26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5454 14.0909C11.1604 14.0909 14.0909 11.1604 14.0909 7.5455C14.0909 3.9305 11.1604 1 7.5454 1C3.9305 1 1 3.9305 1 7.5455C1 11.1604 3.9305 14.0909 7.5454 14.0909Z",
    stroke: "#448B7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54541 4.27148V7.54418H9.99991",
    stroke: "#448B7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.d5bac716d9b69c547035dc7221e52fe6.svg";
export { ForwardRef as ReactComponent };